import React, { useState, useEffect } from 'react';
import { format, addDays, startOfWeek, endOfWeek, addWeeks, subWeeks, parseISO, differenceInMinutes } from 'date-fns';
import { fr } from 'date-fns/locale';
import '../styles/ReservationSalle.css';
import { Modal, Box } from '@mui/material';
import ReservationService from '../services/reservationSalleService';
import SalleService from '../services/salleService';
import FinancementService from '../services/financementService';
import { useNavigate, Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

function Reunion() {
  const [salles, setSalles] = useState([]);
  const [financements, setFinancements] = useState([]);
  const [currentWeek, setCurrentWeek] = useState(new Date());
  const [meetings, setMeetings] = useState([]);
  const [currentReservation, setCurrentReservation] = useState(null);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [selectedRoom, setSelectedRoom] = useState('Grande salle Ambohimiandra');
  const currentDateTime = new Date().toISOString().slice(0, 16);
  const startOfCurrentWeek = startOfWeek(currentWeek, { weekStartsOn: 1 });
  const endOfCurrentWeek = endOfWeek(currentWeek, { weekStartsOn: 1 });

  const fetchData = () => {
    SalleService.all()
      .then(result => {
        if (result.success) {
          setSalles(result.data);
        }
      })
      .catch(error => alert(error.error));

    FinancementService.all()
      .then(result => {
        if (result.success) {
          setFinancements(result.data);
        }
      })
      .catch(error => alert(error.error));

    ReservationService.all()
      .then(result => {
        if (result.success) {
          let meetings = result.data['data'];

          meetings = meetings.map(meeting => ({
            ...meeting,
            debut: meeting.debut.replace('Z', ''),
            fin: meeting.fin.replace('Z', '')
          }));

          setMeetings(meetings);
        }
      })
      .catch(error => alert(error.error));

  };

  useEffect(() => {
    fetchData();
  }, []);


  const formatHour = (datetime) => {
    const date = new Date(datetime);
    return format(date, 'HH') + 'h';
  };

  const handleNextWeek = () => {
    setCurrentWeek(addWeeks(currentWeek, 1));
  };

  const handlePreviousWeek = () => {
    setCurrentWeek(subWeeks(currentWeek, 1));
  };

  const handleDateChange = (e) => {
    setCurrentWeek(new Date(e.target.value));
  };

  const handleOpenAddModal = (date) => {
    setCurrentReservation({ debut: date, fin: date, salle: '', financement: '', objet: '', participants: '', demandeur: '' });
    setOpenAddModal(true);
  };

  const handleOpenEditModal = (reservation) => {
    setCurrentReservation(reservation);
    setOpenEditModal(true);
  };


  const handleCloseEditModal = () => setOpenEditModal(false);
  const handleCloseAddModal = () => setOpenAddModal(false);
  const handleAddReunion = async (event) => {
    event.preventDefault();
    const form = event.target;
    const debut = new Date(form.debut.value);
    const fin = new Date(form.fin.value);
  
    // Obtenez les heures de début et de fin
    const debutHeure = debut.getHours();
    const finHeure = fin.getHours();
  
    // Fonction pour vérifier si une heure est entre 20h et 7h
    const isNightTime = (heure) => {
      return heure >= 20 || heure < 7;
    };
  
    // Vérifiez si les heures de début ou de fin sont entre 20h et 7h
    if (isNightTime(debutHeure) || isNightTime(finHeure)) {
      alert('Les heures de début et de fin ne peuvent pas être entre 20h et 7h.');
      return;
    }
  
    // Vérifiez que la date de fin est le même jour que la date de début
    if (debut.toDateString() !== fin.toDateString()) {
      alert('La date de fin doit être le même jour que la date de début.');
      return;
    }
  
    // Vérifiez que la date de fin est postérieure à la date de début
    if (fin <= debut) {
      alert('La date de fin doit être postérieure à la date de début.');
      return;
    }
  
    const newReservation = {
      debut: form.debut.value,
      fin: form.fin.value,
      id_salle: form.salle.value,
      id_financement: form.financement.value,
      objet: form.objet.value,
      participant: form.participant.value,
      id_demandeur: localStorage.getItem('userId'),
    };
  
  
    try {
      const result = await ReservationService.add(newReservation);
      if (result.success) {
        setMeetings([...meetings, result.data]);
        handleCloseAddModal();
        fetchData();
      } else {
        alert('Erreur lors de l\'ajout: ' + result.error);
      }
    } catch (error) {
      console.error('Erreur lors de l\'ajout:', error);
    }
  };
  
  const handleUpdateReunion = async (event) => {
    event.preventDefault();
    const form = event.target;
    const debut = new Date(form.debut.value);
    const fin = new Date(form.fin.value);
  
    // Obtenez les heures de début et de fin
    const debutHeure = debut.getHours();
    const finHeure = fin.getHours();
  
    // Fonction pour vérifier si une heure est entre 20h et 7h
    const isNightTime = (heure) => {
      return heure >= 20 || heure < 7;
    };
  
    // Vérifiez si les heures de début ou de fin sont entre 20h et 7h
    if (isNightTime(debutHeure) || isNightTime(finHeure)) {
      alert('Les heures de début et de fin ne peuvent pas être entre 20h et 7h.');
      return;
    }
  
    // Vérifiez que la date de fin est le même jour que la date de début
    if (debut.toDateString() !== fin.toDateString()) {
      alert('La date de fin doit être le même jour que la date de début.');
      return;
    }
  
    // Vérifiez que la date de fin est postérieure à la date de début
    if (fin <= debut) {
      alert('La date de fin doit être postérieure à la date de début.');
      return;
    }
  
    const updatedReservation = {
      debut: form.debut.value,
      fin: form.fin.value,
      id_salle: form.salle.value,
      id_financement: form.financement.value,
      objet: form.objet.value,
      participant: form.participant.value,
      id_demandeur: localStorage.getItem('userId'),
    };
  
    try {
      const result = await ReservationService.update(form.id.value, updatedReservation);
      if (result.success) {
        setMeetings(meetings.map((meeting) =>
          meeting.id === currentReservation.id ? result.data : meeting
        ));
        handleCloseEditModal();
        fetchData();
      } else {
        alert('Erreur lors de la mise à jour: ' + result.error);
      }
    } catch (error) {
      console.error('Erreur lors de la mise à jour:', error);
    }
  };
  

  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const handleOpenDeleteModal = () => setOpenDeleteModal(true);
  const handleCloseDeleteModal = () => setOpenDeleteModal(false);
  const handleDeleteReunion = async () => {
    try {
      await ReservationService.delete(currentReservation.id_reservation , localStorage.getItem('accessToken'));
      fetchData();
      handleCloseDeleteModal();
    } catch (error) {
      alert('Erreur lors de la suppression de la réservation.');
    }
  };

  const handleRoomFilterChange = (room) => {
    setSelectedRoom(room);
  };

  const renderTable = () => {
    const days = [];
    for (let i = 0; i < 5; i++) {
      days.push(addDays(startOfCurrentWeek, i));
    }

    const hours = [];
    for (let i = 8; i <= 20; i++) {
      hours.push(i);
    }

    return (
      <div className="table-container">
        <table style={{ tableLayout: 'fixed', width: '100%' }}>
  <thead>
    <tr>
      <th style={{ width: '30px', minWidth: '30px' }}>H</th>
      {days.map((day, index) => (
        <th key={index} style={{ width: '150px', minWidth: '150px' }}>
          {format(day, 'd MMMM yyyy', { locale: fr })}
        </th>
      ))}
    </tr>
  </thead>

  <tbody>
    {hours.map((hour) => (
      <tr key={hour}>
        <td
          style={{
            background: 'white',
            border: '1px solid',
            color: 'black',
            fontWeight: 'bold',
            width: '50px',
            minWidth: '50px',
            height: '62px', // Fixed height for each hour row
            textAlign: 'center',
          }}
        >
          {hour}h
        </td>
        {days.map((day, index) => {
          const dayMeetings = meetings.filter((meeting) => {
            const start = parseISO(meeting.debut);
            const end = parseISO(meeting.fin);
            return (
              start >= startOfCurrentWeek &&
              end <= endOfCurrentWeek &&
              format(start, 'yyyy-MM-dd') === format(day, 'yyyy-MM-dd') &&
              start.getHours() <= hour &&
              end.getHours() > hour &&
              (selectedRoom === 'All' || meeting.salle === selectedRoom)
            );
          });

          if (dayMeetings.length === 0) {
            return (
              <td
                key={index}
                className="time-slot"
                style={{ width: '150px', height: '62px', minHeight: '62px' }} // Fixed size
                onClick={() => handleOpenAddModal(`${format(day, 'yyyy-MM-dd')}T${hour}:00`)}
              ></td>
            );
          }

          const meeting = dayMeetings[0];
          const start = parseISO(meeting.debut);
          const end = parseISO(meeting.fin);
          const duration = differenceInMinutes(end, start);
          const startHour = start.getHours() + start.getMinutes() / 60;
          const hourHeight = 62;
          const meetingHeight = (duration / 60) * hourHeight;

          if (start.getHours() === hour) {
            return (
              <td
                key={index}
                className="time-slot"
                rowSpan={Math.ceil(meetingHeight / hourHeight)}
                onClick={() => handleOpenEditModal(meeting)}
                style={{ width: '150px', height: '62px', minHeight: '62px', fontSize:'12px' }} // Fixed size
              >
                <div
                  className="meeting"
                  style={{
                    height: `${meetingHeight}px`,
                    backgroundColor:
                      meeting.id_salle === 1
                        ? 'rgb(154, 250, 154)'
                        : meeting.id_salle === 2
                        ? 'rgb(154, 231, 250)'
                        : 'rgb(154, 176, 250)',
                    whiteSpace: 'normal', // Allow text wrapping
                    wordWrap: 'break-word', // Break long words if needed
                    overflowWrap: 'break-word', // Ensures wrapping even for long words
                  }}
                  title={`Salle: ${meeting.salle}\nParticipants: ${meeting.participants}\nDemandeur: ${meeting.demandeur}\nDébut: ${format(start, 'HH:mm')}\nFin: ${format(end, 'HH:mm')}`}
                >
                  <div
                    style={{
                      backgroundColor: 'white',
                      color: 'black',
                      fontWeight: 'bold',
                      textAlign: 'center',
                      marginTop: '10px',
                      padding: '5px',
                      borderRadius: '5px',
                    }}
                  >
                    {formatHour(meeting.debut)} - {formatHour(meeting.fin)}
                  </div>
                  <br />
                  <div><strong>Demandeur:</strong> {meeting.demandeur}</div>
                  <div><strong>Objet:</strong> {meeting.objet}</div>
                  <div><strong>Financement:</strong> {meeting.financement}</div>
                  <div><strong>Participants:</strong> {meeting.participant}</div>
                  <div><strong>Salle:</strong> {meeting.salle}</div>
                </div>
              </td>
            );
          }

          return null;
        })}
      </tr>
    ))}
  </tbody>
</table>

      </div>
    );
  };

  return (
    <div className="calendar-container">
      <div className="room-filters">
      <button>
        <Link style={{color:'black',textDecoration:'none',backgroundColor:'white',borderRadius:'5px',padding:'5px 10px'}} to={"/"}> <ArrowBackIcon fontSize='12px'/> retour</Link>
      </button>
        <button
          onClick={() => handleRoomFilterChange('All')}
          className={selectedRoom === 'All' ? 'active' : ''}
        >
          toutes les salles
        </button>
        {salles.map((salle, index) => (
          <button
            key={index}
            onClick={() => handleRoomFilterChange(salle.nom_salle)}
            className={selectedRoom === salle.nom_salle ? 'active' : ''}
          >
            {salle.nom_salle}
          </button>
        ))}
        <span>
          <button style={{ border: '1px solid #E6C795', color: '#E6C795', backgroundColor: 'transparent' }} onClick={handlePreviousWeek}>précedent</button>
          <button style={{ border: '1px solid #E6C795', color: '#E6C795', backgroundColor: 'transparent' }} onClick={handleNextWeek}>suivant</button>
          <input type="date" className='week-picker' value={format(currentWeek, 'yyyy-MM-dd')} onChange={handleDateChange} />
        </span>
      </div>

      {renderTable()}

      <Modal
        open={openEditModal}
        onClose={handleCloseEditModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ maxWidth: 700, margin: 'auto', padding: 2 }}>
          <form id="editForm" onSubmit={handleUpdateReunion}>
            <div className='titre-form'>
              <span>Modifier Réservation Salle</span>
            </div>
            <input type="hidden" name='id' id='id' defaultValue={currentReservation?.id_reservation} />
            <div className="form-group row">
              <div className="col">
                <label htmlFor="debut">Date Début</label>
                <input type="datetime-local" name="debut" id="debut" defaultValue={currentReservation?.debut} required />
              </div>
              <div className="col">
                <label htmlFor="fin">Date Fin</label>
                <input type="datetime-local" name="fin" id="fin" defaultValue={currentReservation?.fin} required />
              </div>
            </div>
            <div>
              <label style={{ fontWeight: 'bold' }}>Financement:</label>
              <div className="radio-group">
                {financements.map((financement, index) => (
                  <div key={index}>
                    <input type="radio" id={`financement-${index}`} name="financement" value={financement.id} defaultChecked={currentReservation?.financement === financement.nom_bailleur} required />
                    <label htmlFor={`financement-${index}`}>{financement.nom_bailleur}</label>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <label style={{ fontWeight: 'bold' }}>Salle:</label>
              <div className="radio-group">
                {salles.map((salle, index) => (
                  <div key={index}>
                    <input type="radio" id={`salle-${index}`} name="salle" value={salle.id} defaultChecked={currentReservation?.salle === salle.nom_salle} required />
                    <label htmlFor={`salle-${index}`}>{salle.nom_salle}</label>
                  </div>
                ))}
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="objet">Objet</label>
              <input type="text" name="objet" id="objet" defaultValue={currentReservation?.objet} required />
            </div>
            <div className="form-group">
              <label htmlFor="participants">Participants</label>
              <input type="number" name="participant" id="participant" defaultValue={currentReservation?.participant} required />
            </div>

          <div className="btn-container">
            <button type="submit">modifier</button>
          </div>

          </form>

          <div className="btn-container" style={{ width: '100%', backgroundColor: 'white', padding: '5px', borderRadius: '5px' }}>
            <button onClick={handleOpenDeleteModal}
              style={{ cursor: 'pointer', float: 'right', backgroundColor: 'red' }}>
              supprimer l'absence
            </button>
          </div>
        </Box>
      </Modal>


      <Modal
        open={openDeleteModal}
        onClose={handleCloseDeleteModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ maxWidth: 500, margin: 'auto', padding: 2 , backgroundColor:'white', borderRadius:'5px' }}>
          <h2 id="modal-modal-title">Confirmer la suppression</h2>
          <p id="modal-modal-description">Êtes-vous sûr de vouloir supprimer cette réservation ?</p>
          <div className="btn-container">
            <button onClick={handleDeleteReunion} style={{ cursor: 'pointer', backgroundColor: 'red' }}>Supprimer</button>
            <button onClick={handleCloseDeleteModal} style={{ cursor: 'pointer', backgroundColor: '#ccc', marginLeft: '10px' }}>Annuler</button>
          </div>
        </Box>
      </Modal>


      {/* Add Modal */}
      <Modal
        open={openAddModal}
        onClose={handleCloseAddModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ maxWidth: 700, margin: 'auto', padding: 2 }}>
          <form id="addForm" onSubmit={handleAddReunion}>
            <div className='titre-form'>
              <span>Ajouter Réservation Salle</span>
            </div>
            <div className="form-group row">
              <div className="col">
                <label htmlFor="debut">Date Début</label>
                <input type="datetime-local" name="debut" id="debut" required />
              </div>
              <div className="col">
                <label htmlFor="fin">Date Fin</label>
                <input type="datetime-local" name="fin" id="fin" required />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="salle">Salle</label>
              <select name="salle" id="salle" required>
                {salles.map((salle, index) => (
                  <option key={index} value={salle.id}>{salle.nom_salle}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="financement">Financement</label>
              <select name="financement" id="financement" required>
                {financements.map((financement, index) => (
                  <option key={index} value={financement.id}>{financement.nom_bailleur}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="objet">Objet</label>
              <input type="text" name="objet" id="objet" required />
            </div>
            <div className="form-group">
              <label htmlFor="participants">Participants</label>
              <input type="number" name="participant" id="participant" required />
            </div>
            <div className="btn-container">
            <button type="submit">ajouter</button>
          </div>
          </form>
        </Box>
      </Modal>
    </div>
  );
}

export default Reunion;
